<template>
  <div>
    <el-row class="el-row-topo">
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item>Termometria</el-breadcrumb-item>
          <el-breadcrumb-item>Orçamentos</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center">
      <el-col :span="24">
        <h1>Orçamentos Termometria Gerencial</h1>
      </el-col>
    </el-row>
    <el-row v-if="permissao.editar_termometria" type="flex" justify="left">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
<!-- 
        <el-form :inline="true" :model="formPesquisa" class="form-inline-pesquisa">
           <el-form-item label="">
            <el-input v-model="formPesquisa.pesquisa" placeholder="Pesquisa por...">
                  <el-button slot="append" @click="onSubmitPesquisa" icon="el-icon-search"></el-button>            
            </el-input>
          </el-form-item> 
        </el-form>
-->
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="24">
        <el-table
          :data="orcamentosTermometria"
          style="width: 100%"
          stripe
          v-loading="loading"
          element-loading-text="Loading..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 255, 255, 0.7)"
        >
<!-- 
        <el-table-column prop="id" label="Orçamento" width="120" sortable>
            <template v-slot="{ row }">
              <span>{{row.id.toString().padStart(6, "0") }}</span>
            </template>
          </el-table-column>
 -->
          <el-table-column prop="sge_cliente" label="Fabricante" width="115" sortable>
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="getFabricanteTooltip(scope.row)"
                placement="top"
              >
                <span>{{ scope.row.sge_cliente }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="users_id" label="Vendedor" width="110" sortable>
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="getUsuarioTooltip(scope.row)"
                placement="top"
              >
                <span>{{ scope.row.users_id }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="orcamento_base" label="Negócio" width="110" sortable></el-table-column>
          <el-table-column prop="orcamento_versao" label="Versão" width="80"></el-table-column>
          <el-table-column prop="cliente.nome" label="Cliente" min-width="350" sortable></el-table-column>
          <el-table-column label="Total sem IPI" width="120" align="right" header-align="right">
            <template v-slot="{ row }">
              <span>  {{formataDolarToReal(parseFloat(row.subtotal)) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="IPI" width="100" align="right" header-align="right">
            <template v-slot="{ row }">
              <span>  {{formataDolarToReal(parseFloat(row.ipi)) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="acao" label="Ação" width="65" filter-placement="bottom-end">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip v-if="permissao.editar_termometria"  class="item" effect="light" content="Imprimir" placement="top">
                  <el-button
                    size="mini"
                    type="success"
                    @click="gerarRelatorioPdfModelo(scope.row)"
                    icon="el-icon-printer"
                  ></el-button>
                </el-tooltip>                
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next"
          background
          :total="total"
        ></el-pagination>
      </el-col>
    </el-row>

  </div>
</template>

<style>
.el-row-topo {
  margin-top: 10px;
}
</style>

<script>

import axios from "axios";
import FuncoesUteis from "../../plugins/FuncoesUteis";

const url = '/api';

export default {
  data() {
    return {
      loading: true,
      currentPage: 1,
      pageSize: 24,
      total: 0,
      sortBy: 'id',
      sortOrder: 'desc',
      orcamentosTermometria: [],
      permissao: {},
      usuario: null,
      formPesquisa: {
        pesquisa: "",
      },
    };
  },
  mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    if (!this.permissao.ler_configuracoes) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    this.usuario = FuncoesUteis.getUsuario();
    this.usuario = this.usuario.id_usuario || 0;

    this.getDados()
  },
  methods: {
    //LISTAR DADOS
    async getDados(paginaCorrente = 0, TamanhoPagina = "") {
      console.log('paginaCorrente',paginaCorrente)
      console.log('TamanhoPagina',TamanhoPagina)
      this.loading = true;
      try {
        const response = await axios.get(`${url}/termometria-orcamento-paginado-2?page=${this.currentPage}&perPage=${this.pageSize}&sortBy=${this.sortBy}&sortOrder=${this.sortOrder}`, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.orcamentosTermometria = response.data.data;
          // console.log("Orçamentos Termometria:", this.orcamentosTermometria);
          this.total = response.data.total;
        }
      } catch (err) {
        console.error("Erro ao buscar Orcamentos de Termometria:", err);
      } finally {
        this.loading = false;
      }

    },

    //PESQUISA
    onSubmitPesquisa() {
      this.loading = true;
      let dados = {
        pesquisa: this.formPesquisa.pesquisa,
      };
      axios
        .post(url + "/userssearch/0/" + this.pageSize, dados, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          this.orcamentosTermometria = response.data.dados;
          this.total = response.data.total;
          this.currentPage = 1;
          this.loading = false;
        })
        .catch((err) => {
          this.orcamentosTermometria = "erro" + err;
        });
    },
    //FIM PESQUISA
    //PAGINAÇÃO
    handleSizeChange: function (size) {
      this.pageSize = size;
      let comeca_em;
      if (this.currentPage == 1) {
        comeca_em = 0;
      } else {
        comeca_em = (this.currentPage - 1) * this.pageSize;
      }
      this.getDados(comeca_em, this.pageSize);
    },
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      let comeca_em;
      if (currentPage == 1) {
        comeca_em = 0;
      } else {
        comeca_em = (currentPage - 1) * this.pageSize;
      }
      this.getDados(comeca_em, this.pageSize);
    },

    //FIM PAGINAÇÃO
    //FIM LISTAR DADOS
    async gerarRelatorioPdfModelo(row) {
      const id = row.id
      try {
        this.loading = true;
        const response = await axios.post(
          url + '/termometria-orcamento-relatorio-pdf-modelo-2',
          { id: id, userId: row.users_id },
          {
            headers: { Authorization: "Bearer " + this.$store.state.token },
            responseType: 'blob',
          }
        );
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
          return;
        }
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const numeroOrcamento = row.orcamento_base;
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `Proposta_${numeroOrcamento}.pdf`;
        link.click();
        this.$message.success('Relatório PDF gerado com sucesso!');
      } catch (error) {
        this.$message.error('Erro ao gerar o PDF (2): ' + (error.response?.data?.message || error.message));
      } finally {
        this.loading = false;
      }
    },
    formataDolarToReal(valor,casasDecimais = 2) {
      if (isNaN(valor) || valor === null) return "0,00";
      let val = new String(valor.toFixed(casasDecimais));
      val = val.replace(",","");
      val = val.replace(".","");
      let tmp = val+'';
      tmp = tmp.replace(/([0-9]{2})$/g, ",$1");
      if( tmp.length > 6 )
          tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
      return tmp;
    },
    getFabricanteTooltip(row) {
      return row.fabricante?.razao_social || '—';
    },
    getUsuarioTooltip(row) {
      return row.usuario?.nome || '—';
    },

  },
};
</script>
<style>
.form-inline-pesquisa {
  margin-top: 15px;
  text-align: left;
  padding-left: 50px;
}
</style>
